import * as React from 'react';

const SvgDay = (props) => (
  <svg
    width={20}
    height={21}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#Day_svg__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.999 1.116c.345 0 .625.28.625.625v1.667a.625.625 0 1 1-1.25 0V1.741c0-.345.28-.625.625-.625ZM3.075 3.984a.625.625 0 0 1 .884 0l1.178 1.179a.625.625 0 1 1-.884.884L3.075 4.868a.625.625 0 0 1 0-.884Zm13.848 0a.625.625 0 0 1 0 .884l-1.18 1.179a.625.625 0 1 1-.883-.884l1.179-1.179a.625.625 0 0 1 .883 0Zm-6.924 2.55a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75Zm-5.625 4.374a5.625 5.625 0 1 1 11.25 0 5.625 5.625 0 0 1-11.25 0Zm-4.167 0c0-.345.28-.625.625-.625h1.667a.625.625 0 1 1 0 1.25H.832a.625.625 0 0 1-.625-.625Zm16.667 0c0-.345.28-.625.625-.625h1.666a.625.625 0 0 1 0 1.25H17.5a.625.625 0 0 1-.625-.625ZM5.137 15.77a.625.625 0 0 1 0 .883L3.96 17.832a.625.625 0 1 1-.884-.884l1.178-1.178a.625.625 0 0 1 .884 0Zm9.723 0a.625.625 0 0 1 .884 0l1.178 1.178a.625.625 0 0 1-.883.884l-1.179-1.179a.625.625 0 0 1 0-.883ZM10 17.782c.345 0 .625.28.625.625v1.667a.625.625 0 1 1-1.25 0v-1.667c0-.345.28-.625.625-.625Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='Day_svg__a'>
        <path fill='#fff' transform='translate(0 .908)' d='M0 0h20v20H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDay;
